<script setup>
import { format } from '@/utils/date-fns';
import { differenceInMinutes } from 'date-fns';
import { computed } from 'vue';
import BasicBlock from '@/components/shared/blocks/BasicBlock.vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  start: {
    type: String,
    default: '',
  },
  end: {
    type: String,
    default: '',
  },
  useTextInsteadOfTime: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();

const formattedStartTime = computed(() => {
  return format(new Date(props.start), 'HH:mm');
});

const formattedEndTime = computed(() => {
  return format(new Date(props.end), 'HH:mm');
});

const durationMinutes = computed(() => {
  return differenceInMinutes(new Date(props.end), new Date(props.start));
});

const durationHours = computed(() => {
  const hours = durationMinutes.value / 60;
  // Only show decimal if there's a fractional part
  if (hours % 1 === 0) {
    return hours.toString();
  }
  return hours.toFixed(1).replace('.', ',');
});

const text = computed(() => {
  let content = `${formattedStartTime.value} - ${formattedEndTime.value}`;

  // 20 hours = 1200 minutes
  if (durationMinutes.value > 1200) {
    content += ` (${durationHours.value} ${t('global.hours')})`;
  }

  return content;
});
</script>

<template>
  <BasicBlock :icon="['fal', 'clock']" :ariaDescription="text" :text="text" />
</template>
